import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 469.9 400"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M352.5 0 0 400h345.7L469.9 0H352.5ZM220.1 324.6c-5.6.7-11.2 1-16.8.9-8.6-.1-14-1.2-18.1-2.8-3.5-1.4-6.6-5.2-5.5-8.1 1-2.2 2.6-4.1 4.8-5.3 10.1-6.5 28.3-9.9 48.4-11.2-1.8 3.9-12.8 26.5-12.8 26.5Zm107-52.5c-14.6 17.2-29 18.4-57.4 15.8-74.6-6.6-89 14-91.4 16.6.5-1.9 1.1-3.8 2-5.5 4.7-10.7 10.4-22.6 16.8-36.8 3.6-7.4 5.6-7.7 8.9-10.1 13.5-8.9 35.2-17.2 64.1-14.7 21.3 1.9 30.6 6.2 43.7 6.9 5.6.4 11.2.1 16.7-.9 14-3 17.6-7.2 17.6-7.2s-10 21.8-21 35.9Zm17.1-45.1c-4.6 2.7-10.6 5.3-22.2 5.7-12.8.4-20.6-2.4-34.7-4.7-19.3-3.1-38-4.3-58.2 2.1-8.6 2.7-16.7 7-23.8 12.6 0 0 14.9-33.5 18.8-42.1 6.4-13.1 27.7-22.5 55.7-22.2 25.2.3 36.5 6.8 57.2 7.1 30.9-.1 41.1-10.4 41.1-10.4-1.8 3.8-11.2 23.5-15.6 31.9-7.3 11.4-12.5 16.6-18.3 20Z",
      style: {"fill":"#001b71"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "FI-logo"}) } }